package com.anjuros.website.templates.template6.sections

import androidx.compose.runtime.Composable
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.rememberCoroutineScope
import androidx.compose.runtime.toMutableStateList
import com.anjuros.website.components.language.LocalText
import com.anjuros.website.components.shared.AnjurosImage
import com.anjuros.website.templates.template6.components.SectionTitle
import com.anjuros.website.templates.template6.modules.Template6Info
import com.anjuros.website.templates.template6.modules.Template6Section
import com.anjuros.website.templates.template6.modules.Template6ServiceInfo
import com.anjuros.website.templates.template6.modules.Template6Theme
import com.anjuros.website.templates.template6.modules.getColor
import com.anjuros.website.templates.template6.modules.getColorOpacity
import com.anjuros.website.templates.template6.util.ResKey
import com.anjuros.website.templates.template6.util.Template6ObserverViewportEntered
import com.varabyte.kobweb.compose.css.CSSTimeNumericValue
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.ObjectFit
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.css.Transition
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.alignItems
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.bottom
import com.varabyte.kobweb.compose.ui.modifiers.boxShadow
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.flexShrink
import com.varabyte.kobweb.compose.ui.modifiers.fontFamily
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.gap
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.id
import com.varabyte.kobweb.compose.ui.modifiers.lineHeight
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.maxWidth
import com.varabyte.kobweb.compose.ui.modifiers.objectFit
import com.varabyte.kobweb.compose.ui.modifiers.opacity
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.position
import com.varabyte.kobweb.compose.ui.modifiers.right
import com.varabyte.kobweb.compose.ui.modifiers.size
import com.varabyte.kobweb.compose.ui.modifiers.transition
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.framework.annotations.DelicateApi
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.theme.breakpoint.rememberBreakpoint
import org.jetbrains.compose.web.css.AlignItems
import org.jetbrains.compose.web.css.Position
import org.jetbrains.compose.web.css.ms
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.rgb
import org.jetbrains.compose.web.css.rgba
import org.jetbrains.compose.web.css.times
import org.jetbrains.compose.web.dom.P
import org.jetbrains.compose.web.dom.Text

@Composable
fun Template6InfoSection(){
    Box(
        modifier = Modifier
            .id("whychoose")
            .fillMaxWidth()
            .backgroundColor(Template6Theme.OpacityPrimary.getColorOpacity())
    ){

        val breakpoint = rememberBreakpoint()

        if(breakpoint>=Breakpoint.LG) {
            Row(
                modifier = Modifier
                    .align(Alignment.Center)
                    .fillMaxWidth(80.percent)
                    .margin(topBottom = 80.px)
                    .gap(70.px)
                    .alignItems(AlignItems.Center)
            ) {


                WhyChooseContent(
                    modifier = Modifier.fillMaxWidth(60.percent)
                )
                WhyChooseImage(
                    modifier = Modifier.fillMaxWidth(40.percent)
                )
            }
        } else {
            Column(
                modifier = Modifier
                    .align(Alignment.Center)
                    .fillMaxWidth(80.percent)
                    .margin(topBottom = 80.px)
                    .gap(70.px)
                    .alignItems(AlignItems.Center),
                verticalArrangement = Arrangement.Center,
                horizontalAlignment = Alignment.CenterHorizontally
            ) {


                WhyChooseContent(
                    modifier = Modifier.fillMaxWidth(100.percent)
                )
                WhyChooseImage(
                    modifier = Modifier.fillMaxWidth(100.percent)
                )
            }
        }
    }
}

@Composable
private fun WhyChooseImage(
    modifier: Modifier
) {

    Box(
        modifier = modifier
            .position(Position.Relative)
    ) {

        AnjurosImage(
            src = "template6-main.webp",
            modifier = Modifier
                .fillMaxWidth()
                .boxShadow(
                    offsetY = 2.px,
                    blurRadius = 5.px,
                    color = rgba(0, 0, 0, 0.4)
                )
                .borderRadius(2.px)
                .objectFit(ObjectFit.Cover)
        )

        Column(
            modifier = Modifier
                .position(Position.Absolute)
                .right(10.px)
                .bottom(10.px)
                .backgroundColor(Template6Theme.Secondary.rgb)
                .borderRadius(10.px)
                .padding(28.px)
        ) {

            P(
                attrs = Modifier
                    .fontSize(34.px)
                    .fontWeight(FontWeight.Bold)
                    .color(Template6Theme.Primary.getColor())
                    .margin(bottom = 8.px)
                    .toAttrs()
            ) {
                Text(LocalText(ResKey.TEMPLATE6_EXPERIENCE_YEARS))
            }

            P(
                attrs = Modifier
                    .fontSize(18.px)
                    .color(Template6Theme.Primary.getColor())
                    .margin(0.px)
                    .toAttrs()
            ) {
                Text(LocalText(ResKey.TEMPLATE6_EXPERIENCE_LABEL))
            }

        }

    }

}

@OptIn(DelicateApi::class)
@Composable
private fun WhyChooseContent(
    modifier: Modifier
) {


    val animatedOpacity = remember {
        MutableList(Template6Info.entries.size) { 0.0f }.toMutableStateList()
    }
    val animatedOpacityWeb = remember { mutableStateOf(0.0f) }
    val breakpoint = rememberBreakpoint()
    val delay = if(breakpoint>=Breakpoint.LG) 600.ms else 0.ms
    if (breakpoint >= Breakpoint.LG) {

        Template6ObserverViewportEntered(
            sectionId = "moreInfo",
            distanceFromTop = 300.0
        ) {
            animatedOpacityWeb.value = 1f
        }

    } else {
        Template6Info.entries.forEach { service ->
            Template6ObserverViewportEntered(
                sectionId = "moreInfo${service.ordinal}",
                distanceFromTop = 600.0
            ) {
                animatedOpacity[service.ordinal] = 1.0f
            }
        }
    }




    Column(
        modifier = modifier
            .id("moreInfo")
            ,
        verticalArrangement = Arrangement.Center,
        horizontalAlignment = Alignment.Start
    ) {

        SectionTitle(
            title =ResKey.TEMPLATE6_WHY_CHOOSE_TITLE,
            subtitle = ResKey.TEMPLATE6_WHY_CHOOSE_SUBTITLE,
            horizontalAlignment = Alignment.Start,
            textAlign = TextAlign.Start
        )

        P(
            attrs = Modifier
                .fontSize(19.px)
                .lineHeight(34.px)
                .color(rgb(95,95,95))
                .margin(top = 30.px, bottom = 42.px)
                .toAttrs()
        ) {
            Text(LocalText(ResKey.TEMPLATE6_WHY_CHOOSE_DESCRIPTION))
        }

        Template6Info.entries.forEach { info ->
            WhyChooseItem(
                template6Info = info,
                animatedOpacity = if (breakpoint >= Breakpoint.LG)
                    animatedOpacityWeb.value
                else
                    animatedOpacity[info.ordinal],
                delay = delay
            )

        }


    }

}

@Composable
private fun WhyChooseItem(
    template6Info: Template6Info,
    animatedOpacity:Float,
    delay: CSSTimeNumericValue
) {

    Row(
        modifier = Modifier
            .id("moreInfo${template6Info.ordinal}")
            .fillMaxWidth()
            .opacity(animatedOpacity)
            .transition(Transition.of("opacity",1200.ms, delay = template6Info.ordinal*delay))
            .margin(bottom = 30.px)
            .gap(10.px)
            .alignItems(AlignItems.Start),
        verticalAlignment = Alignment.CenterVertically
    ) {

        Box(
            modifier = Modifier
                .size(50.px)
                .flexShrink(0)
                .backgroundColor(Template6Theme.Primary.getColor())
                .borderRadius(50.percent)
                .margin(bottom = 28.px),
            contentAlignment = Alignment.Center
        ) {


            Image(
                src = "template6_white_tick.svg",
                modifier = Modifier
                    .size(30.px)
            )


        }

        Column(modifier = Modifier) {

            P(
                attrs = Modifier
                    .fontSize(24.px)
                    .fontWeight(FontWeight.Bold)
                    .color(Template6Theme.Primary.getColor())
                    .margin(bottom = 10.px)
                    .toAttrs()
            ) {
                Text(LocalText(template6Info.title))
            }

            P(
                attrs = Modifier
                    .fontSize(18.px)
                    .lineHeight(30.px)
                    .color(rgb(90,90,90))
                    .margin(0.px)
                    .toAttrs()
            ) {
                Text(LocalText(template6Info.description))
            }

        }

    }

}